import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../../shared/sharedData';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../../shared/services/auth';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ActionSuspend',
  templateUrl: 'actionSuspend.html'
})
export class ActionSuspend {

  public localState: any;
  public _baseUrl: any;
  public employeeId: any;
  public type: any = {};
  public showButtonLoading: any = false;
  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _auth: Auth,
    public share: SharedData,
    public _toaster: ToasterComponent,
    public vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    this.employeeId = data.employeeId;
    this.type = data.type;
  }

  public suspendOrActiveEmployee() {
    let that = this;
    that.showButtonLoading = true;
    let url = that._baseUrl + 'v1/webAdmin/employee/updateEmployeeStatus';
    url += '?employeeId=' + that.employeeId;
    url += '&employeeStatus=' + that.type;
    that.http.get(url).subscribe((result) => {
      if (result.data) {
        if (that.type === 'ACTIVE') {
          that.translate.get('employeeActivatedAlert').subscribe((msg) => {
            that._toaster.showSuccess(msg);
          });
        }
        if (that.type === 'SUSPEND') {
          that.translate.get('employeeSuspendedAlert').subscribe((msg) => {
            that._toaster.showSuccess(msg);
          });
        }
        setTimeout(() => { that.activeModal.close('confirm'); }, 1000);
      } else {
        that.showButtonLoading = false;
        that.translate.get('employeeActionFailed').subscribe((msg) => {
          that._toaster.showError(msg);
        });
      }
    }, (error) => {
      console.log(error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/employeeActions/actionSuspend.ts